export enum AdminDataType {
  Keyword = 2,
  ApiErrorMailList = 3,
  SiteLogo = 4,
  Slider = 5,
  Api = 6,
  MinYear = 7,
  UnLimitedGsmNumber = 8,
  GsmCode = 9,
  KmLimit = 10,
  VisaType = 11,
  VisitReason = 12,
  VisaCountry = 13,
  Religion = 14,
  Profession = 15,
  Education = 16,
  FamilyMemberShip = 17,
  PaymentDefination = 18,
  VisaStatus = 19,
  Uyumsoft = 20,
	CompanyInfo = 21,
  BankaInfos = 22,
  GoogleAnalytics = 23,
  YandexAnalytics = 24,
  TursabNo =25 
}
